//ACCORDION
document.querySelector('body').addEventListener('click', (e) => {
	const target = e.target.closest('[data-accordion]');
	if (!target) return;

	let activeElem = document.querySelector('.accordion.is-open');

	if (activeElem && (activeElem != target.parentElement)) {
		activeElem.classList.remove('is-open');
	}

	target.parentElement.classList.toggle('is-open');
});